export const CUSTOM_SEARCH_DEFINITION_RULE: ValidationRule = {
  id: 'jps-custom_search_definition',
  strict: true,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: true,
      label: {
        ja: 'ID',
        en: 'ID'
      }
    },
    name: {
      field: 'name',
      type: 'object',
      mandatory: false,
      jaMandatory: true,
      objRuleName: 'jps-lang_string_yomi',
      label: {
        ja: '検索名',
        en: 'Name'
      }
    },
    type: {
      field: 'type',
      type: 'string',
      mandatory: true,
      enumKey: 'jps-c_s_type'
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '検索の説明',
        en: 'Description'
      }
    },
    help: {
      field: 'help',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_delta',
      label: {
        ja: '検索のヘルプ',
        en: 'Help'
      }
    },
    databaseIds: {
      field: 'databaseIds',
      type: 'array',
      mandatory: false,
      arraySubType: 'string',
      label: {
        ja: '対象データベース',
        en: 'Target Database'
      }
    },
    searchFields: {
      field: 'searchFields',
      type: 'array',
      mandatory: false,
      objRuleName: 'jps-custom_search_field',
      arraySubType: 'object',
      label: {
        ja: '検索フィールド',
        en: 'Search Fields'
      }
    },
    constraints: {
      field: 'constraints',
      type: 'array',
      mandatory: false,
      objRuleName: 'jps-custom_search_constraint',
      arraySubType: 'object',
      label: {
        ja: '検索制約',
        en: 'Search Constraints'
      }
    },
    columns: {
      field: 'columns',
      type: 'array',
      mandatory: false,
      objRuleName: 'jps-custom_search_column',
      arraySubType: 'object',
      label: {
        ja: '表表示定義',
        en: 'Grid Definition'
      }
    },
    keywordFields: {
      field: 'keywordFields',
      type: 'array',
      mandatory: false,
      arraySubType: 'string',
      label: {
        ja: 'キーワード定義',
        en: 'Keyword Search Definition'
      }
    },
    keywordPlaceholder: {
      field: 'keywordPlaceholder',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'キーワードプレイスホルダー',
        en: 'Keyword Placeholder'
      }
    },
    sorts: {
      field: 'sorts',
      type: 'array',
      mandatory: false,
      arraySubType: 'string'
    },
    image: {
      field: 'image',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-image_selection',
      label: {
        ja: '代表画像',
        en: 'Representative Image'
      }
    }
  }
  , enums: {
    'jps-c_s_type': C_S_TYPE_DEF
  }
}
export const CUSTOM_SEARCH_FIELD_RULE: ValidationRule = {
  id: 'jps-custom_search_field',
  strict: true,
  fields: {
    key: {
      field: 'key',
      type: 'string',
      mandatory: true,
      strPattern: '[_a-z0-9]{1,20}',
      label: {
        ja: 'キー',
        en: 'Key'
      },
      description: {
        ja: '検索フィールドのキーです。一つのテーマ別検索内で重複できません。',
        en: ''
      }
    },
    name: {
      field: 'name',
      type: 'object',
      mandatory: false,
      jaMandatory: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '検索フィールド名',
        en: 'Field Name'
      }
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'フィールドの説明',
        en: 'Description'
      }
    },
    type: {
      field: 'type',
      type: 'string',
      mandatory: true,
      enumKey: 'jps-search_field_type',
      label: {
        ja: '検索フィールド種別',
        en: 'Search Field Type'
      }
    },
    fields: {
      field: 'fields',
      type: 'array',
      mandatory: false,
      arraySubType: 'string',
      label: {
        ja: '検索インデックス',
        en: 'Target Index'
      }
    },
    placeHolder: {
      field: 'placeHolder',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'プレイスホルダー',
        en: 'Place Holder'
      }
    },
    samples: {
      field: 'samples',
      type: 'array',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      arraySubType: 'object',
      label: {
        ja: 'キーワード例',
        en: 'Keyword Sample'
      }
    },
    codeKey: {
      field: 'codeKey',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'コード',
        en: 'Code'
      }
    },
    hidden: {
      field: 'hidden',
      type: 'bool',
      mandatory: false,
      label: {
        ja: '非表示',
        en: 'Hidden'
      }
    },
    hasFacet: {
      field: 'hasFacet',
      type: 'bool',
      mandatory: false,
      label: {
        ja: 'ファセット',
        en: 'Facet'
      },
      description: {
        ja: 'ファセットを有効化します。',
        en: ''
      }
    },
    hasSideBarFacet: {
      field: 'hasSideBarFacet',
      type: 'bool',
      mandatory: false,
      label: {
        ja: 'サイドバーファセット',
        en: 'Side Bar Facet'
      }
    },
    sideBarFacetShowCount: {
      field: 'sideBarFacetShowCount',
      type: 'number',
      mandatory: false,
      numIntOnly: true,
      label: {
        ja: 'サイドバーファセットの表示件数',
        en: 'Side Bar Facet Show Count'
      }
    },
    facetIncludePattern: {
      field: 'facetIncludePattern',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'ファセットに含む値のフィルタ',
        en: 'Filter for facet value'
      },
      description: {
        ja: '正規表現を使って集計対象の値を絞り込むことができます。',
        en: ''
      }
    },
    facetSize: {
      field: 'facetSize',
      type: 'number',
      mandatory: false,
      numMin: 1.0,
      numMax: 50.0,
      numIntOnly: true,
      label: {
        ja: 'ファセットの取得数',
        en: 'Number of values for facet'
      },
      description: {
        ja: 'ファセットで何件までの値を取得してくるか。デフォルトは10件です',
        en: ''
      }
    }
  }
  , enums: {
    'jps-search_field_type': SEARCH_FIELD_TYPE_DEF
  }
}
export const CUSTOM_SEARCH_CONSTRAINT_RULE: ValidationRule = {
  id: 'jps-custom_search_constraint',
  strict: true,
  fields: {
    c: {
      field: 'c',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-search_logic_type',
      label: {
        ja: '制約種別',
        en: 'Constraint Type'
      }
    },
    note: {
      field: 'note',
      type: 'object',
      mandatory: false,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'ノート',
        en: 'Note'
      }
    }
  }
  , enums: {
    'jps-search_logic_type': SEARCH_LOGIC_TYPE_DEF
  }
}
export const CUSTOM_SEARCH_COLUMN_RULE: ValidationRule = {
  id: 'jps-custom_search_column',
  strict: true,
  fields: {
    header: {
      field: 'header',
      type: 'object',
      mandatory: false,
      jaMandatory: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'ヘッダ',
        en: 'Header'
      }
    },
    fields: {
      field: 'fields',
      type: 'array',
      mandatory: false,
      arraySubType: 'string',
      label: {
        ja: '対象フィールド',
        en: 'Field'
      }
    },
    type: {
      field: 'type',
      type: 'string',
      mandatory: true,
      enumKey: 'jps-search_column_type',
      label: {
        ja: 'カラム種別',
        en: 'Column Type'
      }
    },
    codeKey: {
      field: 'codeKey',
      type: 'string',
      mandatory: false,
      label: {
        ja: 'コード値種別（デコードが必要なフィールドの場合）',
        en: ''
      }
    }
  }
  , enums: {
    'jps-search_column_type': SEARCH_COLUMN_TYPE_DEF
  }
}
